import { ADD_TO_SLACK_URL } from 'config';

import React, { Component, PropTypes } from 'react';
import { firebase as fb } from 'redux-firebasev3';
import { browserHistory } from 'react-router';

import Loading from './components/Loading';
import AddToSlackButton from './components/AddToSlackButton';
import ErrorPage from './components/ErrorPage';
import Page from './containers/Page';
import ContactSupport from './components/ContactSupport';
import fetchJSON from './utils/fetchJSON';

@fb()
export default class VerifyAddToSlack extends Component {
  static propTypes = {
    firebase: PropTypes.object,
    location: PropTypes.shape({
      query: PropTypes.shape({
        code: PropTypes.string,
        error: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };

  state = {
    errorMessage: '',
  };

  componentDidMount() {
    const {
      firebase,
      location: { query: { code, error } },
    } = this.props;

    // Slack sets the error query param to access_denied when the user cancels
    // the Add to Slack process. We send them home so they can try again if
    // desired.
    if (error === 'access_denied') {
      if (heap) { heap.track('Add to Slack Cancelled'); }
      return browserHistory.replace('/');
    }

    if (!code) {
      return null;
    }

    return fetchJSON(`${ADD_TO_SLACK_URL}?code=${code}`)
      .then(({ errorMessage, loginToken }) => {
        if (errorMessage) {
          return this.setState({
            errorMessage,
          });
        }

        return firebase.login({ token: loginToken }).then(() => (
          browserHistory.replace('/welcome')
        ));
      })
      .catch((addToSlackError) => this.setState({
        errorMessage: addToSlackError.toString(),
      }));
  }

  render() {
    const {
      location: { query: { code } },
    } = this.props;
    const { errorMessage } = this.state;

    if (errorMessage || !code) {
      if (Raven) {
        const error = !code ? 'Missing Add to Slack Code' : errorMessage;
        Raven.captureMessage('Add to Slack error', {
          extra: { error }
        });
      }

      return (
        <ErrorPage
          subtitle="Please try again:"
          title="Oops! Add to Slack didn’t work."
        >
          <AddToSlackButton className="mv4" />
          <ContactSupport className="mt3" />
        </ErrorPage>
      );
    }

    return (
      <Page pageTitle="Add to Slack">
        <div className="tc">
          <Loading message="Adding to Slack" />
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/VerifyAddToSlack.jsx
 **/